import { oneLineService as service } from 'services/serviceStorage';
import {
    Node,
    GetDiagramResponse
} from "./types";
import { LookupItem } from "common/types";
import { BaseApiResponse } from "common/types";
import { wrapRequest } from "common/utils";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getScenarios = createAsyncThunk<LookupItem[], number>(
    'oneLineDiag/getScenarios',
    async (taskId) => {
        const { data } = await wrapRequest<BaseApiResponse<LookupItem[]>>({
            handler: () => service.getScenarios(taskId),
            showNotifications: true
        });

        return data?.result!;
    }
);

export const getAreas = createAsyncThunk<string[], number>(
    'oneLineDiag/getAreas',
    async (scenarioId) => {
        const { data } = await wrapRequest<BaseApiResponse<string[]>>({
            handler: () => service.getAreas(scenarioId),
            showNotifications: true
        });

        return data?.result!;
    }
);

export const getUnitTypes = createAsyncThunk<string[], number>(
    'oneLineDiag/getUnitTypes',
    async (scenarioId) => {
        const { data } = await wrapRequest<BaseApiResponse<string[]>>({
            handler: () => service.getUnitTypes(scenarioId),
            showNotifications: true
        });

        return data?.result!;
    }
);

export const getNodesLookup = createAsyncThunk<Node[], { scenarioId: number, areas: string[], unitTypes: string[], type: string, searchString: string, }>(
    'oneLineDiag/getNodesLookup',
    async ({ scenarioId, areas, unitTypes, type, searchString, }) => {
        const { data } = await wrapRequest<BaseApiResponse<Node[]>>({
            handler: () => service.getNodesLookup(scenarioId, areas, unitTypes, type, searchString),
            showNotifications: true
        });

        return data?.result!;
    }
);

export const getDiagram = createAsyncThunk<GetDiagramResponse, { scenarioId: number, type: string, steps: number, enode: string }>(
    'oneLineDiag/getDiagram',
    async ({ scenarioId, type, steps, enode }, { rejectWithValue }) => {
        const { data, errors } = await wrapRequest<BaseApiResponse<GetDiagramResponse>>({
            handler: () => service.getDiagram(scenarioId, type, steps, enode),
            showNotifications: false
        });

        if (errors?.length) {
            return rejectWithValue(errors);
        }

        return data?.result!;
    }
);

export const getShortestPath = createAsyncThunk<GetDiagramResponse, { scenarioId: number, fromBus: string, toBus: string }>(
    'oneLineDiag/getShortestPath',
    async ({ scenarioId, fromBus, toBus }) => {
        const { data } = await wrapRequest<BaseApiResponse<GetDiagramResponse>>({
            handler: () => service.getShortestPath(scenarioId, fromBus, toBus),
            showNotifications: true
        });

        return data?.result!;
    }
);

export const clearCache = createAsyncThunk<void, number>(
    'oneLineDiag/clearCache',
    async (scenarioId, { rejectWithValue }) => {
        const err = await wrapRequest<void>({
            handler: () => service.clearCache(scenarioId),
            showNotifications: true
        });

        if (err.errors?.length || err.warnings?.length) {
            return rejectWithValue(err);
        }
    }
);